import React from "react";
import CheckoutContext from "../../checkout-context";
import { OrderSummaryTotalRow } from "./order-summary-total-row";
import { OrderSummaryGrandTotal } from "./order-summary-grand-total";
import { OrderSummaryItems } from "./order-summary-items";
import { OrderSummaryContainer } from "./order-summary-container";

class OrderSummary extends React.Component {
  constructor(props) {
    super(props);
  }

  static contextType = CheckoutContext;

  render() {
    const { cart, textsMapping, checkDiscountActive } = this.context;

    return (
      <OrderSummaryContainer title={textsMapping.orderSummaryTitle}>
        <OrderSummaryItems
          lineItems={cart.lineItems}
          textsMapping={textsMapping}
          checkDiscountActive={checkDiscountActive}
        />

        <div className="order-summary__totals">
          <OrderSummaryTotalRow
            label={textsMapping.orderSummarySubTotal}
            priceNumber={cart.subTotal}
          />

          <OrderSummaryTotalRow
            label={textsMapping.orderSummaryVAT}
            priceNumber={cart.vatTotal}
          />
        </div>

        <OrderSummaryGrandTotal
          label={textsMapping.orderSummaryTotal}
          grandTotalNumber={cart.grandTotal}
        />
      </OrderSummaryContainer>
    );
  }
}

export { OrderSummary };
